import React, { useState, useRef, useEffect } from "react";
import arrowDownGolden from "../../../../assets/images/svg/arrowDownGolden.svg";
import FilledButton from "../../../SelectButton/FilledButton";
import EmptyButton from "../../../SelectButton/EmptyButton";
import { forwardRef } from "react";
//const options = ["India", "Japan", "UK"];

function RadioDropdown(
  {
    selected = { value: "" },
    position,
    items = [],
    handleChange,
    setOpen,
    open,
    dropdownBtnStyles = {},
    valuePropertyName = "value",
    labelPropertyName = "value",
    menuClassName = "",
    containerRef,
  },
  ref
) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [focusedIndex, setFocusedIndex] = useState(0);

  const listRef = useRef(null);

  // Focus selected item when dropdown opens
  useEffect(() => {
    if (isOpen) {
      setFocusedIndex(selectedIndex);

      setTimeout(() => {
        const el = listRef.current?.children[selectedIndex];
        el?.focus();
      }, 0);
    }
  }, [isOpen, selectedIndex]);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        isOpen &&
        containerRef.current &&
        !containerRef.current.contains(e.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  // Handle keyboard
  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setFocusedIndex((prev) => (prev + 1) % items?.length);
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      setFocusedIndex((prev) => (prev === 0 ? items?.length - 1 : prev - 1));
    }

    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleSelect(focusedIndex);
      handleChange(items[focusedIndex]);
    }

    if (e.key === "Escape") {
      setIsOpen(false);
      ref.current?.focus();
    }

    // NEW: Tab should close dropdown and allow natural focus move
    if (e.key === "Tab") {
      setIsOpen(false);
      // DO NOT preventDefault → let browser move focus naturally
    }
  };

  // Select handler
  const handleSelect = (index) => {
    setSelectedIndex(index);
    handleChange(items[index]);
    setIsOpen(false);

    ref.current?.focus();
  };

  // Move focus when navigating
  useEffect(() => {
    if (isOpen && listRef.current) {
      const el = listRef.current.children[focusedIndex];
      el?.focus();
    }
  }, [focusedIndex, isOpen]);

  return (
    <div style={{ position: "relative" }}>
      <div
        ref={containerRef}
        className="info-box-wrapper"
        style={{ width: "200px", position: "relative" }}
      >
        <button
          ref={ref}
          className={`equity-dropdown dropdown_btn`}
          style={dropdownBtnStyles}
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <p className="selected_text equity_dropdown_selected_text">
            {selected?.value?.length > 25
              ? `${selected?.value?.slice(0, 25)}...`
              : selected?.[labelPropertyName]}
          </p>
          <div className={`golden_down_arrow`}>
            <div className="profile_arrow_section">
              <img src={arrowDownGolden} alt="" />
            </div>
          </div>
        </button>

        {isOpen && (
          <div
            role="radiogroup"
            ref={listRef}
            className={`dropdown-content ${menuClassName}`}
            style={{
              ...position,
            }}
            onKeyDown={handleKeyDown}
          >
            {items?.map((accountData, index) => (
              <div
                key={accountData.value}
                role="radio"
                aria-checked={selectedIndex === index}
                tabIndex={focusedIndex === index ? 0 : -1}
                onClick={() => {
                  handleSelect(index);
                  setIsOpen(false);
                }}
                className="data-item"
                style={{
                  borderBottom:
                    index !== items.length - 1 &&
                    "1px solid rgba(214, 214, 214, 0.29)",
                }}
              >
                <div>
                  {accountData[valuePropertyName] ===
                  selected[valuePropertyName] ? (
                    <FilledButton />
                  ) : (
                    <EmptyButton />
                  )}
                </div>
                <input
                  className="input-selector"
                  type="radio"
                  checked={selectedIndex === index}
                  readOnly
                />
                <span className="item-name">
                  {accountData[labelPropertyName]}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default forwardRef(RadioDropdown);
